import { i18n } from '@lingui/core';
import { MessageBus } from '@podium/browser';
import '@warp-ds/icons/elements/alert-16';
import { Modal } from '@warp-ds/react';
import React from 'react';

export type SortingInfoModalProps = {
    messageBusConfig: {
        channel: string;
        topic: string;
    };
    sortingInfo: Array<{ title: string; body: string }>;
};

export function SortingInfoModal(props: SortingInfoModalProps) {
    const { sortingInfo, messageBusConfig } = props;

    const [isOpen, setIsOpen] = React.useState(false);

    React.useEffect(function listenForOpenMessage() {
        function openModal() {
            setIsOpen(true);
        }

        const messageBus = new MessageBus();
        const { channel, topic } = messageBusConfig;

        messageBus.subscribe(channel, topic, openModal);
        return () => messageBus.unsubscribe(channel, topic, openModal);
    }, []);

    return (
        <Modal
            open={isOpen}
            onDismiss={() => setIsOpen(false)}
            right
            title={i18n.t({
                id: 'sorting-info.title',
                message: 'About the ranking of ads',
            })}
        >
            {sortingInfo.map(({ title, body }) => (
                <>
                    <h2 className="h4">{title}</h2>
                    <p className="mb-16">{body}</p>
                </>
            ))}
        </Modal>
    );
}
